import * as sk from './browserless-sk.js';
import * as at from './browserless-at.js';
import * as hu from './browserless-hu.js';
import * as si from './browserless-si.js';
import * as hr from './browserless-hr.js';
import * as it from './browserless-it.js';
import * as fr from './browserless-fr.js';
import * as a1 from './browserless-a1.js';
import * as a2 from './browserless-a2.js';
import * as a4 from './browserless-a4.js';

const BY_KEY = new Map([
  ['a1-amberone-pl', a1],
  ['a2-awsa-pl', a2],
  ['a4-sam-pl', a4],
  ['emyto-sk', sk],
  ['asfinag-at', at],
  ['hugo-hu', hu],
  ['darsgo-si', si],
  ['hac-hr', hr], ['azm-hr', hr], ['bina-istra-hr', hr],
  ['autostrade-it', it],
  ['autoroutes-fr', fr],
]);

export function onCountryBrowserlessMessage(listener) {
  const unsubs = [a1,a2,a4,sk,at,hu,si,hr,it,fr].map(module => module.onMessage(listener));
  return () => unsubs.forEach(unsub => unsub?.());
}

export async function startCountryBrowserlessJob(payload) {
  const module = BY_KEY.get(String(payload?.calculatorKey || ''));
  if (!module) throw new Error(`Brak Browserless dla kalkulatora ${payload?.calculatorKey || '(brak)'}.`);
  return module.startJob(payload);
}

export function isCountryBrowserlessKey(key) { return BY_KEY.has(String(key || '')); }
